var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_c('v-card-title',{staticClass:"px-0"},[_vm._v("\n    Proxers\n  ")]),_c('proxers')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }